import React, { useEffect, useRef, useState } from "react";
import customerIcon from "../Assets/icons/UnmatchedExperience.gif";
import detailsIcon from "../Assets/icons/UnwaveringPrecision.gif";
import qualityIcon from "../Assets/icons/quality-icon.gif";
import customizationIcon from "../Assets/icons/welder.gif";
import "./aboutInfoContainer.css";
import Slider from "react-slick";
import { isMobile } from "../App";

const WhyChooseUs = ({ setInitialIndex, initialIndex }) => {
  const [centerIndex, setCenterIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  const sliderRef = useRef(null);

  const values = [
    {
      img: customerIcon,
      text: (
        <>
          Unmatched
          <br />
          Experience
        </>
      ),
      description:
        "46 years of experience, ensuring every weld whispers expertise",
    },
    {
      img: detailsIcon,
      text: <>Unmatched<br />Detail</>,
      description: "Laser-sharp accuracy that guarantees superior performance",
    },
    {
      img: qualityIcon,
      text: (
        <>
          Uncompromising
          <br />
          Quality
        </>
      ),
      description:
        "Only the finest materials, crafted with state-of-the-art technology for lasting reliability",
    },
    {
      img: customizationIcon,
      text: (
        <>
          Unbounded
          <br />
          Customization
        </>
      ),
      description:
        "Your vision is our blueprint, no matter how intricate it may be",
    },
  ];

  const settings = {
    vertical: true,
    useCSS: true,
    centerMode: true,
    centerPadding: "0px",
    autoplay: !isPaused,
    slidesToShow: 3,
    focusOnSelect: true,
    speed: 500,
    autoplaySpeed: 1250,
    infinite: true,
    beforeChange: (_, next) => setCenterIndex(next),
  };

  // useEffect(() => {
  //   if (initialIndex) {
  //     setCenterIndex(0);
  //     sliderRef.current?.slickGoTo(0);
  //   }
  // }, [initialIndex]);

  useEffect(() => {
    if (isPaused) {
      sliderRef.current?.slickPause();
    } else {
      sliderRef.current?.slickPlay();
    }
  }, [isPaused]);

  const handlePause = (index) => {
    if (index === centerIndex && !isPaused) {
      setIsPaused(true);
    }
  };

  const handleResume = (index) => {
    if (index === centerIndex && isPaused) {
      setTimeout(() => {
        setIsPaused(false);
      }, 100); // small delay for smoother effect
    }
  };

  return (
    <div className="about-info-container" id="core-values">
      <p className="title-text-about" id="why-choose-us">
        Why Choose Us?
      </p>
      <div className="center-slider">
        <Slider ref={sliderRef} {...settings}>
          {values.map((value, index) => {
            const isCenter = index === centerIndex;
            const showDescription = isCenter && isPaused;

            return (
              <div
                key={index}
                className={`core_value_icon_cover ${
                  showDescription ? "activecard" : "inactivecard"
                }`}
                onMouseEnter={() => handlePause(index)}
                onMouseLeave={() => handleResume(index)}
                onTouchStart={() => handlePause(index)}
                onTouchEnd={() => handleResume(index)}
              >
                <div
                  className={`content-wrapper ${
                    showDescription ? "hidden-content" : ""
                  }`}
                >
                  <img src={value.img} alt={value.text} />
                  <p>{value.text}</p>
                </div>

                <div
                  className={`content-wrapper ${
                    showDescription ? "" : "hidden-content"
                  }`}
                >
                  <p className="m-0 textdescription">{value.description}</p>
                </div>
              </div>
            );
          })}
        </Slider>
      </div>
      <pageXOffset className="mt-3 text-center description-text">
        Choose <b>Alok</b> for fabrication that goes beyond the ordinary — where
        craftsmanship meets innovation, and excellence is not just a goal but a
        tradition.
      </pageXOffset>
      <pageXOffset className="mt-4 text-center description-text">
        <b>Crafting Tomorrow, Today — Alok Fabrications</b>
      </pageXOffset>
    </div>
  );
};

export default WhyChooseUs;
  